import { TinyEmitter } from 'tiny-emitter';

export default TinyEmitter;
